import { render, staticRenderFns } from "./supplydemandremain.vue?vue&type=template&id=18179a2c&scoped=true&"
import script from "./supplydemandremain.vue?vue&type=script&lang=js&"
export * from "./supplydemandremain.vue?vue&type=script&lang=js&"
import style0 from "./supplydemandremain.vue?vue&type=style&index=0&id=18179a2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18179a2c",
  null
  
)

export default component.exports